import { InvoiceExportTypeId } from '@previo/codebooks'
import { DefaultCountryStrategy } from '~/pages/setting/applications/accounting/exports/software/i10n/countries/DefaultCountryStrategy'

export class SVKCountryStrategy extends DefaultCountryStrategy {
  public allowedSoftware: InvoiceExportTypeId[] = [InvoiceExportTypeId.POHODA]
}
